import { BlockDataForm } from '@plone/volto/components/manage/Form';
import PropTypes from 'prop-types';

import { linkMapSchema } from './schema';
import { STATE_PROP_TYPES } from './states';

const LinkMapData = (props) => {
  const { data, block, onChangeBlock, blocksErrors } = props;
  const schema = linkMapSchema(props);

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeBlock={onChangeBlock}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
      errors={blocksErrors}
    />
  );
};

LinkMapData.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    linkTemplate: PropTypes.string,
    useDarkTheme: PropTypes.bool,
    ...STATE_PROP_TYPES,
  }),
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
  blocksErrors: PropTypes.object,
};

export default LinkMapData;
